module.exports = __webpack_public_path__ + "static/media/goods_and_rawmaterials.6c4d5251.svg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/goods_and_rawmaterials.svg
// module id = 726
// module chunks = 0